module.exports = {
      id: "image-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#image",
      toString: function () {
        return this.url;
      }
    }